import { render, staticRenderFns } from "./GroupImages.vue?vue&type=template&id=586776d2&scoped=true"
import script from "./GroupImages.vue?vue&type=script&lang=js"
export * from "./GroupImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586776d2",
  null
  
)

export default component.exports